<template lang="pug">
  q-card
    q-card-main
      q-field(label-width="2", label="Geometry:")
        .flex.row.justify-around
          span(v-katex="'D='+d")
          span(v-katex="'R='+r")
          span(v-katex="'Z='+z")
          span(v-katex="'D_{\\\\text{eff}}='+d_eff")
          span(v-katex="'D_{\\\\text{flat}}='+d_flat")
      q-field(label-width="2", label="Cutting Parameters:")
        .flex.row.justify-around
          span(v-katex="'a_p='+ap")
          span(v-katex="'a_e='+ae")
          span(v-katex="'v_c='+vc")
          span(v-katex="'v_f='+vf")
          span(v-katex="'f_z='+fz")
</template>

<script>
export default {
  name: 'GeometryEditor',
  props: ['d', 'r', 'z', 'd_eff', 'd_flat', 'ap', 'ae', 'vc', 'vf', 'fz'],
  data: function () {
    return {
      parent: null
    };
  }
}
</script>
